import React from 'react';
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Typography,
    Chip,
    Button,
    Box,
    IconButton,
    Grid,
    Tooltip,
    CircularProgress
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const UnbuildAdvice = ({ 
    pendingAdvice, 
    loadingPaymentLinks, 
    fetchPendingAdvice, 
    BookId,
    handleSendPaymentLink 
}) => {
    const navigate=useNavigate()
    if (!pendingAdvice || pendingAdvice.length === 0) {
        return null;
    }

    return (
        <Grid container sx={{ mt: 1 }}>
            <Grid item xs={12}>
                <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                        mb: 1,
                        fontSize: { xs: '0.85rem', sm: '0.95rem' },
                        fontWeight: 'bold',
                        color: '#1976d2',
                        background: 'lightgray',
                        padding: { xs: '6px 8px', sm: '8px 12px' },
                        borderRadius: '4px',
                        borderLeft: '4px solid #1976d2'
                    }}
                >
                    ⏳ Unbuild Payment Advice
                </Typography>
                <TableContainer
                    component={Paper}
                    sx={{
                        maxHeight: 200,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        border: '1px solid #e0e0e0',
                        borderRadius: '8px',
                        background: 'linear(145deg, #ffffff, #fafafa)',
                        overflowX: 'auto'
                    }}
                >
                    <Table
                        stickyHeader
                        size="small"
                        sx={{
                            minWidth: 650,
                            '& .MuiTableCell-root': {
                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                border: '1px solid #e0e0e0',
                                lineHeight: '1.2'
                            },
                            '& .MuiTableHead-root .MuiTableCell-root': {
                                background: 'linear(45deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                padding: { xs: '4px 6px', sm: '6px 8px' },
                                borderBottom: '2px solid #5a6fd8',
                                whiteSpace: 'nowrap'
                            },
                            '& .MuiTableBody-root .MuiTableCell-root': {
                                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                                padding: { xs: '2px 4px', sm: '4px 6px' },
                                whiteSpace: 'nowrap'
                            },
                            '& .MuiTableRow-root': {
                                height: { xs: '28px', sm: '32px' },
                                cursor: 'pointer'
                            }
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    width: { xs: '12%', sm: '10%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }}>Advice No</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }}>Advice Date</TableCell>
                                <TableCell sx={{
                                    width: { xs: '12%', sm: '10%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }}>Advice For</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="right">Amount</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="right">Received</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="right">Balance</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="center">Due Days</TableCell>
                                <TableCell sx={{
                                    width: { xs: '10%', sm: '8%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="center">Due Date</TableCell>
                                <TableCell sx={{
                                    width: { xs: '14%', sm: '12%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }}>Remark</TableCell>
                                <TableCell sx={{
                                    width: { xs: '22%', sm: '20%' },
                                    background: '#d7dbd1ff !important',
                                    color: 'black !important'
                                }} align="center">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pendingAdvice.map((item, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        height: { xs: '25px', sm: '28px' },
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: '#f8fbff'
                                        },
                                        '&:nth-of-type(even)': {
                                            backgroundColor: '#ffffff'
                                        },
                                        '&:hover': {
                                            backgroundColor: '#f0f7ff'
                                        }
                                    }}
                                    onDoubleClick={() => {
                                        const url = `/advicegeneratetable?PytAdvId=${item.PytAdvId}`;
                                        window.open(url, '_blank');
                                    }}
                                >
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        fontWeight: 'bold',
                                        color: '#1565c0',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}>
                                        {item?.PytAdvNo}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        color: '#666',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}>
                                        {moment(item?.PytAdvDt).format("DD-MM-YYYY")}
                                    </TableCell>
                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }}>
                                        <Chip
                                            label={
                                                item?.PytAdvFor === "D" ? "Deposit" :
                                                    item?.PytAdvFor === "R" ? "Rent" :
                                                        item?.PytAdvFor === "O" ? "Other" :
                                                            item?.PytAdvFor === "T" ? "TopUp" : ""
                                            }
                                            size="small"
                                            sx={{
                                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                height: { xs: '16px', sm: '18px' },
                                                fontWeight: 'bold',
                                                backgroundColor:
                                                    item?.PytAdvFor === "D" ? '#e8f5e9' :
                                                        item?.PytAdvFor === "R" ? '#fff3e0' :
                                                            item?.PytAdvFor === "O" ? '#f3e5f5' :
                                                                '#e1f5fe',
                                                color:
                                                    item?.PytAdvFor === "D" ? '#2e7d32' :
                                                        item?.PytAdvFor === "R" ? '#ef6c00' :
                                                            item?.PytAdvFor === "O" ? '#7b1fa2' :
                                                                '#0277bd'
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        fontWeight: 'bold',
                                        color: '#2e7d32',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }} align="right">
                                        ₹{item?.Amount}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }} align="right">
                                        ₹{item?.RcdAmt || '0'}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        fontWeight: 'bold',
                                        color: item?.BalAmount > 0 ? '#d32f2f' : '#2e7d32',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }} align="right">
                                        ₹{item?.BalAmount}
                                    </TableCell>
                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                        <Chip
                                            label={item?.DueDays}
                                            size="small"
                                            sx={{
                                                fontSize: { xs: '0.6rem', sm: '0.65rem' },
                                                height: { xs: '16px', sm: '18px' },
                                                fontWeight: 'bold',
                                                color: 'white',
                                                backgroundColor:
                                                    item?.DueDays === 0 ? '#4caf50' :
                                                        item?.DueDays <= 7 ? '#ff9800' :
                                                            item?.DueDays <= 30 ? '#f44336' :
                                                                '#d32f2f'
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        color: '#666',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}>
                                        {moment(item?.PytAdvDt).format("DD-MM-YYYY") || "-"}
                                    </TableCell>
                                    <TableCell sx={{
                                        padding: { xs: '2px 4px', sm: '4px 6px' },
                                        color: '#666',
                                        fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                    }}>
                                        {item?.Remark || "-"}
                                    </TableCell>
                                    <TableCell sx={{ padding: { xs: '2px 4px', sm: '4px 6px' } }} align="center">
                                        <Box sx={{
                                            display: 'inline-flex',
                                            gap: 0.5,
                                            flexWrap: { xs: 'wrap', sm: 'nowrap' },
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="primary"
                                                onClick={()=>navigate('/advicegeneratetable')}
                                                sx={{
                                                    padding: { xs: '1px 6px', sm: '2px 8px' },
                                                    minWidth: 'auto',
                                                    fontSize: { xs: '0.55rem', sm: '0.6rem' },
                                                    height: { xs: '20px', sm: '22px' },
                                                    background: 'linear(45deg, #2196F3, #21CBF3)',
                                                    boxShadow: '0 1px 3px rgba(33, 150, 243, 0.3)',
                                                    '&:hover': {
                                                        background: 'linear(45deg, #1976D2, #00B0FF)',
                                                        boxShadow: '0 2px 5px rgba(33, 150, 243, 0.4)'
                                                    }
                                                }}
                                             
                                            >
                                                {loadingPaymentLinks[item.PytAdvId] ? (
                                                    <CircularProgress size={10} sx={{ color: 'white' }} />
                                                ) : (
                                                    '💡 Genrate-Advice'
                                                )}
                                            </Button>

                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};

export default UnbuildAdvice;